import classNames from "classnames";
import Styles from "./Icon.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Icon = ({ iconName, size = "small", className = "" }) => {
  return (
    <FontAwesomeIcon className={classNames(Styles[`icon${className}`])}icon={iconName} />
  );
};

export default Icon;
